import { defineStore } from "pinia";
import { ref } from "vue";

export const useGlobalStore = defineStore(
  "globalStoreDetails",
  () => {
    const sitecoreData: any = ref(null);
    const allowedTerminals: any = ref({});

    const updateSitecoreData = (data: any) => {
      sitecoreData.value = data;
    };

    const updateAllowedTerminals = (data: any) => {
      allowedTerminals.value = data;
    };
    return {
      sitecoreData,
      allowedTerminals,
      updateSitecoreData,
      updateAllowedTerminals
    };
  },
  {
    persist: false
  }
);
